import React from 'react'
import {airBlue} from '@modifi/colors'
import {Caption, Col} from '@modifi/ui'

import {StyledRow} from './styles'

type ActionItemProps = {
  icon: React.ElementType
  label: string
  iconSize?: number
  onClick?: React.MouseEventHandler<HTMLDivElement>
  ident: string
}

const ActionItem: React.FC<ActionItemProps> = ({
  icon: ActionIcon,
  label,
  iconSize = undefined,
  onClick = undefined,
  ident,
}) => (
  <StyledRow alignItems="center" onClick={onClick} data-ident={ident}>
    <Col col={2}>
      <ActionIcon color={airBlue} width={iconSize || 20} height={iconSize || 20} />
    </Col>
    <Col col={10}>
      <Caption>{label}</Caption>
    </Col>
  </StyledRow>
)

export default ActionItem
